import React from 'react'
import { WithTranslation, withTranslation } from 'react-i18next'
import Flex from 'typescript-styled-flex'
import { NumberInput } from '../../../components/FormBuilder'
import { withSize } from '../../../hooks/useSize'
import { IWithSize } from '../../BookingCalendar/Calendar/Calendar'

const renderSubFields = (label, size) => (member, index, fields) => {
  const even = index % 2 === 0
  const lastAndEven =
    (fields.length - 1) % 2 === 0 ? index === fields.length - 1 : false
  return (
    <div
      style={{
        ...{ width: lastAndEven ? '100%' : '50%' },
        ...(even
          ? { paddingRight: !lastAndEven ? `${10 * size}px` : '0px' }
          : { paddingLeft: `${10 * size}px` }),
      }}
      key={`${label}${index}${fields.length}`}
    >
      <NumberInput.ReduxField
        width={'100%'}
        size={size}
        style={{ maxWidth: '100%', width: '100%' }}
        key={member}
        minValueForNumber={0}
        maxValueForNumber={17}
        onlyInteger={true}
        name={`${member}.age`}
        label={`${label} ${index + 1})`}
        isSmallReservation={true}
        inputStyle={{ maxWidth: '100%', minWidth: 0 }}
      />
    </div>
  )
}

function renderChildrenAge({
  fields,
  t,
  size,
}: WithTranslation & { fields: any } & IWithSize) {
  return (
    <Flex full={true} wrap={true} alignEnd={true}>
      {fields.map(
        renderSubFields(`${t('z677_age')} (${t('BBO_963_child')}`, size),
      )}
    </Flex>
  )
}

export const ChildrenAge = withSize(withTranslation()(renderChildrenAge))
